export default __webpack_public_path__ + "079ca05d3ded9bc107ab8a8da013be22.ttf";